import React from 'react';
import ASSETS from '../../../assets';

const TakeControl = () => {
  return (
    <div className='md:mt-[120px] mt-12 bg-l-primary lg:p-12 md:p-6 p-5 lg:rounded-[24px] rounded-[12px] flex lg:flex-row flex-col items-center gap-10 justify-between'>
      <div>
        <p className='lg:text-[32px] text-3xl font-semibold text-white max-w-[25ch]'>
          Take Control of Your Legal Matters Today
        </p>
        <p className='text-base font-medium text-l-text-w max-w-[49ch] mt-4'>
          Legal issues can be daunting, but our app simplifies it. <br /> Access
          legal advice, document prep, and case management easily and
          efficiently.
        </p>
        <div className='flex flex-wrap items-center gap-4 lg:mt-[104px] mt-12'>
          <a
            href='https://apps.apple.com/us/app/legal-avenue/id6474690584'
            target='_blank'
            rel='noreferrer'
          >
            <div className='w-[200px] bg-white rounded-md p-3 flex items-center gap-3'>
              <img src={ASSETS.appStore} alt='' />
              <div>
                <p className='text-sm text-l-primary'>Download on the</p>
                <p className='text-base font-semibold text-l-primary leading-5'>
                  App Store
                </p>
              </div>
            </div>
          </a>
          <a
            href='https://play.google.com/store/apps/details?id=com.techconsultivo.legalavenue'
            target='_blank'
            rel='noreferrer'
          >
            <div className='w-[200px] bg-white rounded-md p-3 flex items-center gap-3'>
              <img src={ASSETS.playStore} alt='' />
              <div>
                <p className='text-sm text-l-primary'>Get in on</p>
                <p className='text-base font-semibold text-l-primary leading-5'>
                  Play Store
                </p>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div>
        <img src={ASSETS.lady} className='h-full max-h-[352px]' alt='' />
      </div>
    </div>
  );
};

export default TakeControl;
